module.exports = __webpack_public_path__ + "media/evolve/assets/icons/atlas/atlas-logo-67bd010cf73ead29672d2734d1d083dd.svg";